<i *ngIf="icon && !icon.startsWith('fa-')" class="material-icons">{{icon}}</i>
<i *ngIf="icon && icon.startsWith('fa-')" aria-hidden="true" class="fa {{icon}}"></i>
<div>{{text}}</div>
<i *ngIf="iconRight && !iconRight.startsWith('fa-')" class="material-icons right">{{iconRight}}</i>
<i *ngIf="iconRight && iconRight.startsWith('fa-')" aria-hidden="true" class="fa {{iconRight}}"></i>
